import ManageEmailTemplate from "../ManageEmailTemplate";
import Drawer from "../../../../drawer/Drawer";

const ManageEmailTemplateDrawer = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  return (
    <Drawer
      open={open}
      onClose={(val) => {
        close(val);
      }}
      actualSize={"xl3"}
      size={"xl3"}
      title={
        data?._id ? (
          <span className="tracking-tighter uppercase font-bold">
            Update Email
          </span>
        ) : (
          <span className="tracking-tighter uppercase font-bold">
            Add Email
          </span>
        )
      }
      subtitle="View, update and modify user details and information bellow"
      drawerBodyClass="p-0 max-h-[calc(100%-42px)]"
    >
      <ManageEmailTemplate
        getResponse={getResponse}
        close={close}
        data={data}
      />
    </Drawer>
  );
};

export default ManageEmailTemplateDrawer;
